import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import LocalSection from './components/LocalSection';
import MandaoOptions from './components/MandaoOptions';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Coverage from './components/Coverage';
import Benefits from './components/Benefits';
import BusinessSection from './components/BusinessSection';
import TrustSection from './components/TrustSection';
import FinalCta from './components/FinalCta';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import MobileBottomNav from './components/MobileBottomNav';
import PwaInstallPrompt from './components/PwaInstallPrompt';
import './App.css';
import './responsive-pwa.css';

function App() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return undefined;
    }

    const registerWorker = () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    };

    window.addEventListener('load', registerWorker);
    return () => window.removeEventListener('load', registerWorker);
  }, []);

  return (
    <div className="app">
      <Header />
      <Hero />
      <LocalSection />
      <MandaoOptions />
      <Services />
      <HowItWorks />
      <Coverage />
      <Benefits />
      <BusinessSection />
      <TrustSection />
      <FinalCta />
      <ContactSection />
      <Footer />
      <FloatingWhatsApp />
      <MobileBottomNav />
      <PwaInstallPrompt />
    </div>
  );
}

export default App;